/**
 * @description Component-TokenPairLeverage
 */
import './index.less';

import { Tag } from 'antd';
import cls from 'classnames';
import { FC, useMemo } from 'react';

import { WrappedBigNumber } from '@/entities/WrappedBigNumber';
import { formatNumber } from '@/utils/numberUtil';
interface IPropTypes {
  leverage: WrappedBigNumber | number | undefined;
  highlight?: boolean;
  tag?: boolean;
}
const TokenPairLeverage: FC<IPropTypes> = function ({ leverage, highlight, tag }) {
  const dom = useMemo(
    () => (
      <span
        className={cls(``, {
          'token-pair-highlight': highlight,
        })}>
        <span>{WrappedBigNumber.from(leverage || 0).lt(1) ? '<1' : formatNumber(leverage || 0, 0)}x</span>
      </span>
    ),
    [highlight, leverage],
  );
  return tag ? (
    <Tag bordered={true} className="token-pair-leverage">
      {dom}
    </Tag>
  ) : (
    <div className="token-pair-leverage">{dom}</div>
  );
};

export default TokenPairLeverage;
